import { Subject } from 'rxjs';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-base-widget',
	styleUrls: ['./base-widget.component.css'],
	templateUrl: './base-widget.component.html'
})
export class BaseWidgetComponent implements OnInit, OnDestroy {
	public showLoad = true;
	public hasData = true;
	public reloadSubscription;
	public responseData;
	public columns: any;
	public requestSubscription: Subject<any>;

	@Input() key: string;
	@Input() columnsconfig: any;

	constructor(protected analyticsService: AnalyticsService) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.columns = JSON.parse(decodeURI(this.columnsconfig));
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.requestSubscription) {
			this.requestSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = false;

		if (this.requestSubscription) {
			this.requestSubscription.unsubscribe();
		}
		this.requestSubscription = this.analyticsService
			.processWidgetRequest(this.key, this.columns)
			.subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data.length > 0) {
					this.hasData = true;
					this.responseData = response.data;
					this.processResponseData(this.responseData);
				} else {
					this.hasData = false;
				}
			});
	}

	processResponseData(responseData: any): void {}
}
